export default __webpack_public_path__ + "static/media/main_page.3309c8ad.jpg";